import { BaseLayout } from "@components/general/base_layout";
import { Header } from "@components/general/header";
import { AndroidDataEventMap } from "@declarations/event";
// import { useBiometricStore } from "@stores/biometric.store"; // biometric belum terpakai
import { AccountService } from "@services/account.service";
import { useInboxStore } from "@stores/inbox.store";
import { useThemeStore } from "@stores/theme.store";
// import { androidSetupBiometric } from "@utils/android"; // biometric belum terpakai
import { androidTokenFirebase, androidUnreadInbox } from "@utils/android";
import { useCallback, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { linkPage } from "@utils/router";

export const HomePage = () => {
  const navigate = useNavigate();
  // const { updateStatusBiometric } = useBiometricStore((state) => state); // biometric belum terpakai
  const { updateUnreadInbox } = useInboxStore((state) => state);
  const { setBottomNavigation } = useThemeStore((state) => state);

  const onUnreadInboxListener = useCallback(
    (ev: MessageEvent<AndroidDataEventMap["on-unread-inbox"]>) => {
      updateUnreadInbox(ev.data);
    },
    [updateUnreadInbox]
  );

  // Biometric listeners — belum terpakai, dinonaktifkan sementara
  // const onIsAvailableBiometricListener = useCallback(
  //   (ev: MessageEvent<AndroidDataEventMap["on-is-available-biometric"]>) => {
  //     localStorage.setItem("is-biometric", `${ev.data}`);
  //     const skip = localStorage.getItem("skip-biometric");
  //     if (skip !== "true") {
  //       localStorage.setItem("skip-biometric", "true");
  //       androidSetupBiometric("register");
  //     }
  //   },
  //   []
  // );
  //
  // const onSetupBiometric = useCallback(
  //   (ev: MessageEvent<AndroidDataEventMap["on-setup-biometric"]>) => {
  //     localStorage.setItem("status-biometric", ev.data);
  //     updateStatusBiometric(ev.data === "register");
  //   },
  //   [updateStatusBiometric]
  // );

  const onTokenFirebaseListener = useCallback(
    (ev: MessageEvent<AndroidDataEventMap["on-token-firebase"]>) => {
      if (!ev.data) return;
      AccountService.updateTokenFirebase(ev.data);
    },
    []
  );

  const onNotificationClickListener = useCallback(
    (ev: MessageEvent<AndroidDataEventMap["on-notification-click"]>) => {
      androidUnreadInbox();
      try {
        const parsed = JSON.parse(ev.data);
        navigate(parsed?.link ?? linkPage.HOME_DASHBOARD);
      } catch {
        navigate(ev.data || linkPage.HOME_DASHBOARD);
      }
    },
    [navigate]
  );

  useEffect(() => {
    setBottomNavigation("home");
  }, [setBottomNavigation]);

  // useEffect(() => {
  //   // window.addEventListener("on-unread-inbox", onUnreadInboxListener);
  //   window.addEventListener(
  //     "on-is-available-biometric",
  //     onIsAvailableBiometricListener
  //   );
  //   window.addEventListener("on-setup-biometric", onSetupBiometric);
  //
  //   return () => {
  //     // window.removeEventListener("on-unread-inbox", onUnreadInboxListener);
  //     window.removeEventListener(
  //       "on-is-available-biometric",
  //       onIsAvailableBiometricListener
  //     );
  //     window.removeEventListener("on-setup-biometric", onSetupBiometric);
  //   };
  // }, [onIsAvailableBiometricListener, onSetupBiometric]);

  useEffect(() => {
    const updateTokenFirebase = setTimeout(() => androidTokenFirebase(), 1000);
    androidUnreadInbox();

    window.addEventListener("on-token-firebase", onTokenFirebaseListener);
    window.addEventListener("on-unread-inbox", onUnreadInboxListener);
    window.addEventListener(
      "on-notification-click",
      onNotificationClickListener
    );

    return () => {
      clearTimeout(updateTokenFirebase);
      window.removeEventListener("on-token-firebase", onTokenFirebaseListener);
      window.removeEventListener("on-unread-inbox", onUnreadInboxListener);
      window.removeEventListener(
        "on-notification-click",
        onNotificationClickListener
      );
    };
  }, [onTokenFirebaseListener, onUnreadInboxListener, onNotificationClickListener]);
  return (
    <>
      <BaseLayout>
        <Header />

        <Outlet />
      </BaseLayout>
    </>
  );
};
